import { Box } from "@mui/material";
import { useContext, useEffect } from "react";
import { ThemeContext } from "../../../context/themeContext";
import RatingsHeader from "./components/header";
import RatingsContent from "./components/text";
import { useSelector } from "react-redux";
import useSettings from "../../../hooks/useSettings";
import useProtectedAuth from "../../../hooks/useProtectedAuth";

const UserRatings = () => {
  useProtectedAuth();
  const { theme } = useContext(ThemeContext);
  const { userScores } = useSelector((state) => state.settings);
  const { recalculateScore, fetchUserScores } = useSettings();

  useEffect(() => {
    const fetchScore = async () => {
      if (userScores === null) {
        await recalculateScore();
        await fetchUserScores();
      }
    };

    fetchScore();
  }, []);

  return (
    <Box
      sx={{
        background: theme.palette.lightgrey.lightgrey600,
        minHeight: "100vh",
        width: "100%",
        marginBottom: "5rem",
      }}
    >
      <RatingsHeader />
      <RatingsContent userScores={userScores} />
    </Box>
  );
};

export default UserRatings;
